import { render, staticRenderFns } from "./VirtualPOIList.vue?vue&type=template&id=156290ff&scoped=true"
import script from "./VirtualPOIList.vue?vue&type=script&lang=ts"
export * from "./VirtualPOIList.vue?vue&type=script&lang=ts"
import style0 from "./VirtualPOIList.vue?vue&type=style&index=0&id=156290ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156290ff",
  null
  
)

export default component.exports